export const companies = [
  { name: "sls", url: `${process.env.REACT_APP_GET_ALL_VIDEO}` },
  // { name: "sls", url: "http://159.196.157.153:4021/api/videos" },
  // { name: "frnsw", url: "http://159.196.157.153:4001/api/videos" },
  // { name: "uts", url: "http://159.196.157.153:4001/api/videos" },
  // { name: "council", url: "http://159.196.157.153:4001/api/videos" },
  // { name: "ta", url: "http://159.196.157.153:4001/api/videos" },
];
